import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Flatten Array - 2",
  url: "faltten-array-2",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {number[][]} arr
* @param {number} depth
* @return {number[]}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function flattenArray(arr, depth) {
  // your code goes here        
};
`,
};

export default info;
